import React, {useState} from 'react';
import Page from './page';
import {useDispatch, useSelector} from 'react-redux';
import Api from '../../util/api';
import {navigateNext, navigateToScreen, setRoom} from '../../action/actions';
import {FormControl} from 'react-bootstrap';
import Button from './Button';
import {publicBuildUrl} from '../../config/config';

const StartOrResume = () => {
    const dispatch = useDispatch();
    const [name, setName] = useState('');
    const [roomNotFound, setRoomNotFound] = useState(false);
    const [resume, setResume] = useState(false);
    const {app: {room: {ageGroup, participants}}} = useSelector((state) => state);


    const handleStart = async () => {
        const response = await Api.createRoom(ageGroup, participants);

        if (response === null) {
            alert('Something went wrong, please try again');
        }

        dispatch(setRoom(response.id, response.room));
        dispatch(navigateNext());
    };

    const handleRoomNameChanged = (value) => {
        setRoomNotFound(false);
        setName(value.toString().toUpperCase());
    };

    const handleRestart = async () => {
        const response = await Api.roomInfo(name);

        if (response === null) {
            setRoomNotFound(true);
            return;
        }

        dispatch(setRoom(response.id, response.room));

        // call room info
        // navigate to page
        // dispatch(navigateNext());
        Api.navigateToLastVisitedScreen().then(
            (response) => dispatch(navigateToScreen(response.screen))
        );
    };

    return (
        <Page title={'Start or resume'}>
            <div className={'bodyContainer'}>
                <div className={'bodyContainerColumn'}>
                    <img src={`${publicBuildUrl}images/StartOrResumeCharacters.png`} alt={'Cast'} style={{width: '560px'}}/>
                </div>
                <div className={'bodyContainerColumn'}>
                    {!resume &&
                    <div style={{
                        display: 'flex',
                        width: '250px',
                        flexDirection: 'column',
                    }}>
                        <Button onClick={handleStart} color={'pink'} text={'Start nieuw spel'}/>
                        <Button onClick={() => setResume(true)} color={'green'} text={'Hervat spel'}/>
                    </div>}

                    {resume &&
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}>
                        <div style={{
                            ...styles.button,
                        }}>
                            <div style={styles.labelContainer}>
                                <div style={styles.labelText}>Spelcode</div>
                            </div>
                            <div>
                                <FormControl
                                    style={styles.input}
                                    placeholder='XXXXX'
                                    aria-label='Deelnemers'
                                    aria-describedby='Deelnemers'
                                    value={name}
                                    onChange={(e) => handleRoomNameChanged(e.target.value)}
                                />
                            </div>
                            <div style={styles.buttonConfirmContainer} onClick={() => handleRestart()}>
                                <div style={styles.buttonConfirmText}>&gt;</div>
                            </div>
                        </div>
                        <div style={styles.error}>&nbsp; {roomNotFound && 'Kamer niet gevonden'}</div>
                    </div>
                    }
                </div>
            </div>
        </Page>
    )
};

const styles = {
    container: {
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'row',
        justifyContent: 'space-around',
    },
    button: {
        display: 'flex',
        cursor: 'pointer',
        width: '560px',
        alignItems: 'center',
    },
    labelContainer: {
        backgroundColor: '#003d4c',
        display: 'flex',
        width: '200px',
        height: '124px',
        borderBottomLeftRadius: 8,
        borderTopLeftRadius: 8,
        justifyContent: 'center',
        alignItems: 'center',
    },
    labelText: {
        color: '#ffffff',
        fontFamily: 'Ubuntu',
        fontSize: '25px',
        fontWeight: 500,
        outline: 'none',
    },
    input: {
        borderWidth: 0,
        color: '#E42460',
        height: '124px',
        width: '120px',
        fontFamily: 'Ubuntu',
        fontSize: '25px',
        textAlign: 'center',
    },
    buttonConfirmContainer: {
        backgroundColor: '#003d4c',
        display: 'flex',
        width: '50px',
        height: '124px',
        borderBottomRightRadius: 8,
        borderTopRightRadius: 8,
        justifyContent: 'center',
        alignItems: 'center',
    },
    buttonConfirmText: {
        color: '#ffffff',
        cursor: 'pointer',
        fontFamily: 'Ubuntu',
        fontSize: '25px',
        fontWeight: 500,
    },
    error: {
        color: 'red',
        fontFamily: 'Ubuntu',
        fontSize: '25px',
        fontWeight: 500,
        marginTop: '25px',
    }
}

export default StartOrResume;
